import { saveAs } from 'file-saver';
import ErrorMessage from '../../../Elements/ErrorMessage';
import PlanningExportService from '../../../Services/PlanningExportService';

// serviceFunction for the GeneralEditWizzard: resolves to {} on success (modal closes)
// or {error} (modal stays open and shows the error).
export default function planningExportDownload(editedItem) {
  return PlanningExportService.Export(editedItem.Level, editedItem.Granularity, editedItem.SelectedIds)
    .then((base64) => {
      if (base64 && base64.error) {
        return { error: base64.error };
      }
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const filename = `Planning_${editedItem.Level}_${editedItem.Granularity}.xlsx`;
      saveAs(
        new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        filename
      );
      return {};
    })
    .catch(() => {
      ErrorMessage.SetErrorMessage('PEXP01');
      return { error: 'Export failed.' };
    });
}
